<div class="confirm-dialog-container">
  <div class="heading-container flex-row flex-justify-space-between flex-align-center">
    <h2 mat-dialog-title [translate]="data.header"></h2>
    <button mat-button class="close-button" [mat-dialog-close]="false">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <div *ngIf="data.image" class="flex-row flex-justify-center img-container">
      <img [src]="data.image" />
    </div>

    <p [innerHtml]="data.description | translate | gbSafe: 'html'" class="confirm-description"></p>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="gb-flex-button-container flex-grow">
      <button mat-raised-button cdkFocusInitial [mat-dialog-close]="false" *ngIf="data.cancelButtonText">
        {{ data.cancelButtonText | translate }}
      </button>
      <button
        mat-raised-button
        color="primary"
        [mat-dialog-close]="true"
        class="btn-yes"
        [class.btn-full-width]="!data.cancelButtonText"
      >
        {{ data.confirmButtonText | translate }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
